<div
  class="u-padding-0-16"
  fxLayout.gt-xs="row"
  fxLayout="column"
  fxLayoutAlign="start center"
>
  <div fxFlex="112px" class="u-position-relative">
    @if (profile?.portrait_original_url || !isUser) {
      <a
        [routerLink]="['.']"
        aria-label="Go to main profile page"
        i18n-aria-label="@@profileView.intro.goToMainProfilePage"
        class="u-display-block"
      >
        <app-avatar-account
          [item]="profile"
          [showCamera]="false"
          [size]="96"
          class="u-display-block"
        >
        </app-avatar-account>
      </a>
    } @else {
      <button
        (click)="openImageUploadDialog(profile)"
        aria-label="Add profile picture"
        i18n-aria-label="@@profileView.intro.addProfilePicture"
        class="c-button"
      >
        <app-avatar-account
          [item]="profile"
          [showCamera]="true"
          [size]="96"
          class="c-button"
        >
        </app-avatar-account>
      </button>
    }
    <ng-container *ngIf="!isLoadingImage && canEdit">
      <div
        class="u-position-absolute"
        [ngStyle]="{ top: '-10px', right: '4px' }"
      >
        <ng-container *ngIf="!!profile.portrait_original_url">
          <button mat-icon-button [matMenuTriggerFor]="editMenu">
            <span
              class="u-borderRadius--50 bg-color-blue u-width-100 u-height-100 u-display-block"
            >
              <span
                fxLayout="row"
                fxLayoutAlign="center center"
                class="u-height-100 u-display-block"
              >
                <i class="material-icons color-white md-18 u-position-relative">
                  edit
                </i>
              </span>
            </span>
          </button>
        </ng-container>
        <ng-container *ngIf="!profile.portrait_original_url">
          <button mat-icon-button (click)="openImageUploadDialog(profile)">
            <span
              class="u-borderRadius--50 bg-color-blue u-width-100 u-height-100 u-display-block"
            >
              <span
                fxLayout="row"
                fxLayoutAlign="center center"
                class="u-height-100 u-display-block"
              >
                <i class="material-icons color-white md-18 u-position-relative">
                  edit
                </i>
              </span>
            </span>
          </button>
        </ng-container>
        <mat-menu #editMenu="matMenu">
          <button
            i18n="@@profileView.intro.changeImage"
            mat-menu-item
            (click)="openImageUploadDialog(profile)"
          >
            Change Image
          </button>
          <button
            i18n="@@profileView.intro.deleteImage"
            mat-menu-item
            (click)="deleteImage()"
          >
            Delete Image
          </button>
        </mat-menu>
      </div>
    </ng-container>
    <ng-container *ngIf="isLoadingImage">
      <div
        class="u-position-absolute u-width-100 u-height-100"
        [ngStyle]="{ top: '0', 'background-color': 'transparent' }"
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        <app-progress-spinner class="u-display-block"></app-progress-spinner>
      </div>
    </ng-container>
  </div>
  <div fxFlex="calc(100% - 112px)" fxLayout.gt-xs="row" fxLayout="column">
    <ng-container *ngIf="tenantState | async as tenant">
      <div
        fxFlex.gt-xs="70%"
        [ngClass.lt-sm]="'u-textAlign-center u-marginBottom-16'"
      >
        <p
          i18n="@@profileView.intro.inactiveProfileTag"
          *ngIf="user.isAdmin && !isUser && 'inactive' === profile.status"
          class="text-caption color-orange u-textUppercase"
        >
          (Inactive profile)
        </p>
        <a [routerLink]="['.']">
          <h6>
            {{ profile | appAccountFullName }}
            <span
              *ngIf="
                (profile | appDisplayUserPronouns) &&
                tenant.enabled_features?.profile
              "
              class="color-grey-300 text-subtitle-1 u-wordWrap-breakWord u-text-maxWidth"
            >
              {{ profile | appDisplayUserPronouns }}
            </span>
          </h6>
        </a>
        <p
          *ngIf="!isUser"
          class="text-subtitle-1 color-grey u-wordWrap-breakWord u-text-maxWidth"
        >
          {{ profile.short_bio }}
        </p>
        <div *ngIf="isUser">
          <p
            *ngIf="!!profile.short_bio"
            class="text-subtitle-1 u-wordWrap-breakWord"
          >
            {{ profile.short_bio }} (<button
              i18n="@@global.edit"
              class="c-button color-blue u-textDecoration-underline--hover"
              (click)="openHeadlineDialog(profile, user)"
            >
              Edit</button
            >)
          </p>
          <button
            *ngIf="!profile.short_bio"
            i18n="@@profileView.intro.addHeadline.buttonLabel"
            class="c-button color-blue u-textDecoration-underline--hover text-subtitle-1"
            (click)="openHeadlineDialog(profile, user)"
          >
            Add headline
          </button>
        </div>
      </div>
    </ng-container>
    <div
      fxFlex.gt-xs="30%"
      fxLayout="row"
      fxLayoutAlign.gt-xs="end center"
      fxLayoutAlign="center center"
      fxLayoutGap="8px"
      [ngClass.lt-sm]="'u-marginBottom-16'"
    >
      <ng-container
        *ngIf="
          !isUser &&
          canStartConversation &&
          (tenantState | async)?.enabled_features?.conversations
        "
      >
        <app-profile-action
          [analyticName]="'profileIntro'"
          [profile]="profile"
          [user]="user"
          class="u-display-inlineBlock"
        >
        </app-profile-action>
      </ng-container>
      <div
        *ngIf="canEdit"
        class="u-display-inlineBlock"
        fxShow.gt-xs="true"
        fxShow="false"
      >
        <ng-container *ngIf="!isUser">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <div [ngStyle]="{ 'min-width': '170px' }">
              <button
                i18n="@@global.editProfile"
                mat-menu-item
                (click)="openEditDialog(profile, user)"
              >
                Edit Profile
              </button>
              <button
                *ngIf="tenantIceBreakers.length"
                i18n="@@profileView.intro.editIcebreakers.buttonLabel"
                mat-menu-item
                (click)="openIcebreakerEditDialog(profile, user)"
              >
                Edit Icebreakers
              </button>
              <button
                i18n="@@profileView.intro.reportProfile.buttonLabel"
                mat-menu-item
                (click)="openReportDialog()"
              >
                Report Profile
              </button>
              <button
                *ngIf="user.isAdmin"
                mat-menu-item
                (click)="deleteAccount(profile)"
              >
                <span
                  i18n="@@profileView.intro.deleteAccount.buttonLabel"
                  class="color-orange"
                  >Delete Account</span
                >
              </button>
            </div>
          </mat-menu>
        </ng-container>
        <ng-container *ngIf="isUser">
          <button mat-stroked-button (click)="openEditDialog(profile, user)">
            <span i18n="@@global.editProfile" class="color-blue"
              >Edit Profile</span
            >
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<app-profile-intro-menu
  [profile]="profile"
  [user]="user"
  class="u-display-block"
></app-profile-intro-menu>
